import LookupType from "./Lookup-type";

export default class LookupData {
    constructor (rawData = {}) {
        this.id = rawData.id;
        this.name = rawData.name;
        this.lookupType = new LookupType(rawData.lookupType);
    }
}